import {TerminalQrCodeCard} from "@/features/user/terminalQrCodeCard";

export function TerminalPanel() {
	return (
		<div className="panel panel-flat">
			<div className="panel-heading">
				<h5 className="panel-title">{messages["authToken.terminal.title"]}</h5>
			</div>
			<div className="panel-body">
				<TerminalQrCodeCard
					user={{id: globals.userId, name: globals.userFullname, login: globals.userLogin}}
				/>
			</div>
		</div>
	);
}
